import { render } from "./FridgeMyAssistEditingPage.vue?vue&type=template&id=83be0954&scoped=true&ts=true"
import script from "./FridgeMyAssistEditingPage.vue?vue&type=script&lang=ts"
export * from "./FridgeMyAssistEditingPage.vue?vue&type=script&lang=ts"

import "./FridgeMyAssistEditingPage.vue?vue&type=style&index=0&id=83be0954&scoped=true&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83be0954"]])

export default __exports__